import React from "react";
import Icon from "@mdi/react";
import { mdiClose, mdiCartCheck } from "@mdi/js";
import { DateTimePicker } from "react-widgets";

const DEFAULT_PRODUCT_IMAGE =
  "data:image/svg+xml;charset=UTF-8,%3Csvg width='220' height='220' viewBox='0 0 220 220' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='220' height='220' rx='12' fill='%23f1f5f9'/%3E%3Cpath d='M62 155h96V75H62v80zm10-70h76v60H72V85z' fill='%23cbd5e1'/%3E%3Ccircle cx='92' cy='105' r='10' fill='%23e2e8f0'/%3E%3Cpath d='M75 140l28-28 18 18 12-12 17 22H75z' fill='%23e2e8f0'/%3E%3Ctext x='110' y='180' text-anchor='middle' font-size='14' font-family='Arial' fill='%2394a3b8'%3ENo image%3C/text%3E%3C/svg%3E";

export default function ModalTaoDonBaoGia({
  orderModal,
  onClose,
  isOrdering,
  orderSelectedIds,
  toggleItem,
  isCheckedAll,
  toggleAll,
  getItemKey,
  orderTotalMoney,
  orderNote,
  setOrderNote,
  orderExpectedDate,
  setOrderExpectedDate,
  isDateOpen,
  setIsDateOpen,
  submitOrder,
}) {
  if (!orderModal) return null;

  return (
    <div className="baogia-overlay" onClick={() => !isOrdering && onClose()}>
      <div
        className="baogia-modal baogia-order-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="baogia-modal-header">
          <span>Tạo đơn đặt hàng — {orderModal.maBaoGia}</span>
          {!isOrdering && (
            <button
              className="cart-shop-remove"
              onClick={onClose}
              style={{ padding: "4px 8px" }}
            >
              <Icon path={mdiClose} size={0.85} />
            </button>
          )}
        </div>
        <div className="baogia-modal-body">
          <div className="cart-shop-layout">
            {/* Left: product list */}
            <div className="cart-shop-left">
              <div className="cart-shop-select-all">
                <label>
                  <input
                    type="checkbox"
                    checked={isCheckedAll}
                    onChange={(e) => toggleAll(e.target.checked)}
                  />
                  <span>Chọn tất cả</span>
                </label>
              </div>
              <div className="cart-shop-list">
                {orderModal.items.map((item) => {
                  const key = getItemKey(item);
                  const selected = orderSelectedIds.includes(key);
                  return (
                    <div
                      key={key}
                      className="baogia-quote-item"
                      style={{
                        background: selected ? "#f0f7ff" : "#fff",
                        borderColor: selected ? "#02499b" : "#dde5ee",
                      }}
                      onClick={() => toggleItem(key, !selected)}
                    >
                      <div className="cart-shop-check-cell">
                        <input
                          type="checkbox"
                          className="cart-shop-checkbox"
                          checked={selected}
                          onChange={() => {}}
                          //onClick={(e) => e.stopPropagation()}
                          onClick={() => toggleItem(key, !selected)}
                        />
                      </div>
                      <div className="baogia-item-img-wrap">
                        <img
                          src={item.CategoryImage || DEFAULT_PRODUCT_IMAGE}
                          alt={item.CategoryName}
                          className="baogia-item-img"
                          onError={(e) => {
                            e.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                          }}
                        />
                      </div>
                      <div className="cart-shop-info">
                        <div className="cart-shop-name">
                          {item.CategoryName}
                        </div>
                        {item.OptionName && (
                          <div className="cart-shop-desc">
                            {item.OptionName}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "#555",
                          textAlign: "right",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {Number(item.Quantity || 0).toLocaleString()}{" "}
                        {item.DisplayName || ""}
                      </div>
                      <div className="cart-shop-price">
                        {Number(item.DonGia || 0) === 0
                          ? "Liên hệ"
                          : `${Number(item.DonGia).toLocaleString()}đ`}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right: summary */}
            <div className="cart-shop-summary">
              <div className="cart-summary-row total">
                <span>TỔNG CỘNG</span>
                <b>
                  {orderTotalMoney > 0
                    ? `${orderTotalMoney.toLocaleString()}đ`
                    : "—"}
                </b>
              </div>
              <div className="cart-summary-line" />
              <div className="cart-shop-note">
                <label>Ghi chú đơn hàng</label>
                <textarea
                  value={orderNote}
                  onChange={(e) => setOrderNote(e.target.value)}
                  rows={3}
                />
              </div>
              <div className="cart-date-row" style={{ marginTop: 14 }}>
                <label>Thời gian nhận hàng dự kiến</label>
                <DateTimePicker
                  value={orderExpectedDate}
                  onChange={(v) => setOrderExpectedDate(v)}
                  min={new Date()}
                  format={"DD/MM/YYYY HH:mm:ss"}
                  time={false}
                  culture="vi"
                  open={isDateOpen}
                  onFocus={() => setIsDateOpen("date")}
                  onBlur={() => setIsDateOpen(false)}
                  onSelect={() => setIsDateOpen(false)}
                />
              </div>
              <div className="cart-total-product" style={{ marginTop: 10 }}>
                Sản phẩm đã chọn: <b>{orderSelectedIds.length}</b>
              </div>
              <button
                className="cart-payment-btn"
                onClick={submitOrder}
                disabled={isOrdering}
              >
                <Icon path={mdiCartCheck} size={0.95} />
                {isOrdering ? "Đang đặt hàng..." : "Đặt hàng"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
